import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface PreferencesState {
  key: 'camelot' | 'classic' | 'metadata';
}

const initialState: PreferencesState = {
  key: 'metadata',
};

export const PreferencesSlice = createSlice({
  name: 'preferences',
  initialState: initialState,
  reducers: {
    setKey: (state, action: PayloadAction<PreferencesState['key']>) => {
      state.key = action.payload;
    },
  },
});

export const { setKey } = PreferencesSlice.actions;

export default PreferencesSlice.reducer;
